import React, { Component } from 'react';
import Map from 'lodash/map';
//import Filter from 'lodash/filter';
import PropTypes from 'prop-types';
import * as axios from 'axios';
import * as moment from 'moment';
import './MakerspacePeople.scss';

//declare var jquery: any;
//declare var $: JQueryStatic;

declare var document:any;

class MakerspacePeople extends Component {
  

  isVideo() {
    if(this.props.videoUrl) {
      return ' video';
    } else {
      return '';
    }
    //search-api/news/_search?query_string=*
  }

  constructor(props) {
    super(props);

    this.id = moment().toDate().getTime();
    

    this.state = {
      data: {
        hits: {
          hits: []
        }
      },
      id:  this.id,
      currentSlide: 1
    };
  }

  componentDidMount() {
    let keywords = this.props.keywords;
    keywords = Map(keywords, (item, key) => {
      return item.trim();
    });

    
    let mustMatchKeywords = [];
    keywords.forEach((item) => {
      let data = {};
      data.match = { "categories_terms" : item };
      mustMatchKeywords.push(data);
    });
    


    let paramsBody = {
      'from': (this.props.from)? parseInt(this.props.from, 10): 0,
      'size': (this.props.size)? parseInt(this.props.size, 10): 12,
      'query': {}
    };

    if(this.props.keywordsOperator === 'OR') {
      paramsBody.query.bool = {
        minimum_should_match: 1,
        should: mustMatchKeywords,
        must: { "query_string": { "query":  (this.props.query)? this.props.query: '*' }}
      };


    } else {
      paramsBody.query.bool = {
        must: mustMatchKeywords
      };
      mustMatchKeywords.push({ "query_string": { "query":  (this.props.query)? this.props.query: '*' }});
    }



    let sortBy = {};
    let sortByField = (this.props.sortField)? this.props.sortField: 'title';
    sortBy['cover_image'] = { 
      'order': (this.props.sortOrder)? this.props.sortOrder: 'desc'
    };
    sortBy[sortByField] = { 
      'order': (this.props.sortOrder)? this.props.sortOrder: 'desc'
    };

    paramsBody.sort = [sortBy];


    axios({
      method: 'POST',
      url: '/search-api/'+this.props.site+'/'+this.props.contentType+'/_search',
      headers: {
        'Content-Type': 'application/json'
      },
      data: JSON.stringify(paramsBody)
    }).then((response) => {
      console.log(paramsBody);
      console.log(response);
      this.setState({ data: response.data, ready: true, id:  this.id});

    })
    .catch((error) => {
      //console.log(error);
    });
    
  }





  render() {
    if(this.state.ready) {
      if(this.state.data.hits.hits.length) { 


        return (
	        <div>
	        <h4>Our Experts</h4>
			<div className="people-brick">
          
			{this.state.data.hits.hits.map((d,i) =>
				<a className="people-card" href={d._source.base_url + '/' + d._source.alias}>
					<div key={i} className="people">
						<img src={d._source.image_square} alt={d._source.title} />
						<div className="name-tag-container">
				  			<div className="name-tag">
				  				<h1 className="name">{d._source.title}</h1>
				  				<p className="title">{d._source.position.value}</p>
				  				<span className="link"><a href={d._source.base_url + '/' + d._source.alias}>View Profile</a></span>
				  			</div>
				  		</div>
				  		</div>
				  	</a>
				)}

            
          </div>
          </div>);
        } else {
          return (<div></div>);
        }

    } else {
      return (<div>LOADING...</div>);
    }
  }
}


MakerspacePeople.propTypes = {
  size: PropTypes.number,
  from: PropTypes.number,
  sortOrder: PropTypes.string,
  sortField: PropTypes.string,
  query: PropTypes.string,
 
  // A value of any data type
  site: PropTypes.string.isRequired,
  contentType: PropTypes.string,
  subheader: PropTypes.string,
  header: PropTypes.string,
  keywords: PropTypes.array.isRequired,
};

export default MakerspacePeople;






// WEBPACK FOOTER //
// ./src/MakerspacePeople/MakerspacePeople.js